<template>
  <div class="home">
    <section class="hero is-medium is-primary prim-background">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <h2 class="title has-text-left">
                {{ $t("SECTION_1_TITLE") }}
              </h2>
              <p
                class="subtitle has-text-left mt-3"
                v-html="parseMessageToHtml('SECTION_1_MESSAGE')"
              />
              <div class="columns mt-3">
                <div class="column">
                  <a :href="$t('ANDROID_STORE_LINK')" target="_blank">
                    <SVGImage SVGFile="android_badge.png"></SVGImage>
                  </a>
                </div>
                <div class="column">
                  <a :href="$t('IOS_STORE_LINK')" target="_blank">
                    <SVGImage SVGFile="ios_badge.png"></SVGImage>
                  </a>
                </div>
                <div class="column"></div>
              </div>
              <p
                class="subtitle has-text-left mt-3"
                v-html="parseMessageToHtml('SECTION_1_LANGUAGES')"
              />
            </div>

            <div class="column">
              <SVGImage SVGFile="home_cards.png"></SVGImage>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-medium is-primary null-bg">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column pt-6">
              <SVGImage SVGFile="gameplay.png" class="pt-6"></SVGImage>
            </div>

            <div class="column">
              <h3 class="title has-text-left">{{ $t("SECTION_2_TITLE") }}</h3>
              <p
                class="subtitle has-text-left mt-6"
                v-html="
                  parseWordForLink(
                    'SECTION_2_MESSAGE',
                    'EU-JAMRAI',
                    'https://eu-jamrai.eu'
                  )
                "
              />
            </div>
          </div>
          <div class="columns is-vcentered mt-6">
            <div class="column">
              <h3 class="title has-text-left">{{ $t("SECTION_3_TITLE") }}</h3>
              <p
                class="subtitle has-text-left mt-6"
                v-html="parseMessageToHtml('SECTION_3_MESSAGE')"
              />
            </div>
            <div class="column">
              <a @click="playVideo()">
                <SVGImage v-if="!videoPlaying" SVGFile="video.png"></SVGImage>
              </a>
              <youtube
                :player-vars="playerVars"
                v-if="videoPlaying"
                style="width: 100%;"
                :video-id="videoUrl"
                ref="youtube"
              ></youtube>
            </div>
          </div>
          <div class="columns mt-6">
            <div class="column mx-6">
              <SVGImage SVGFile="players_icon.png" class="mc-icon"></SVGImage>
              <h4 style="font-size: 18px" class="mt-3">
                {{ $t("SECTION_4_ICON_1") }}
              </h4>
            </div>
            <div class="column mx-6">
              <SVGImage SVGFile="timer_icon.png" class="mc-icon"></SVGImage>
              <h4 style="font-size: 18px" class="mt-3">
                {{ $t("SECTION_4_ICON_2") }}
              </h4>
            </div>
            <div class="column mx-6">
              <SVGImage SVGFile="cards_icon.png" class="mc-icon"></SVGImage>
              <h4 style="font-size: 18px" class="mt-3">
                {{ $t("SECTION_4_ICON_3") }}
              </h4>
            </div>
            <div class="column mx-6">
              <SVGImage SVGFile="age_icon.png" class="mc-icon"></SVGImage>
              <h4 style="font-size: 18px" class="mt-3">
                {{ $t("SECTION_4_ICON_4") }}
              </h4>
            </div>
          </div>
          <div class="columns is-vcentered mt-6">
            <div class="column">
              <SVGImage SVGFile="medicine.png"></SVGImage>
            </div>
            <div class="column is-left">
              <h3 class="title has-text-left">{{ $t("SECTION_5_TITLE") }}</h3>
              <p
                class="subtitle has-text-left mt-6"
                v-html="
                  parseWordForLink(
                    'SECTION_5_MESSAGE',
                    'ISGlobal',
                    'https://www.isglobal.org/micro-combat'
                  )
                "
              />
              <a
                :href="$t('SECTION_5_URL')"
                target="_blank"
                class="ctr-button button is-pulled-left"
                >{{ $t("SECTION_5_BUTTON") }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import SVGImage from "../components/SVGImage";

export default {
  name: "Home",
  components: {
    SVGImage
  },
  data() {
    return {
      videoPlaying: false
    };
  },
  mounted() {},
  methods: {
    playVideo() {
      this.videoPlaying = true;
    },
    parseMessageToHtml(key) {
      return this.$t(key).replace(/\n/g, "<br />");
    },
    parseWordForLink(key, word, url) {
      const linkTag = '<a href="' + url + '" target="_blank">' + word + "</a>";
      return this.parseMessageToHtml(key).replace(word, linkTag);
    }
  },
  computed: {
    videoUrl() {
      return this.$youtube.getIdFromUrl(this.$t("SECTION_3_VIDEO_URL"));
    },
    playerVars() {
      return {
        autoplay: this.videoPlaying ? 1 : 0
      };
    }
  }
};
</script>
